import { ComputeFieldComponent } from "../../computeFields";

export const LocalisationCF: ComputeFieldComponent<{
  localisation: string;
}> = ({ input, lineBreak = false }) => {
  const localisation = input.localisation ?? "";

  return (
    <>
      {localisation}
      {localisation && localisation !== "" && lineBreak && <br />}
    </>
  );
};
